module.exports = __webpack_public_path__ + "img/icon-russian.fed51737.svg";